
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {sancionStore} from "@/store/sancionStore";
import {http} from "@/config/HttpClient";
import {DateTime} from "luxon";
import {MaterialService} from "@/services/MaterialService";
import {Alert} from "@/addons/Alert";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";
import {materialStore} from "@/store/materialStore";
import {IngresoService} from "@/services/IngresoService";
import {SalidaService} from "@/services/SalidaService";
import {ingresoStore} from "@/store/ingresoStore";
import {salidaStore} from "@/store/salidaStore";
import * as stream from "stream";

@Component({
  name: "CompraMaterialesNew",
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  sancion = {
    codigo: '',
    meses_plazo: 1,

  }

  @Prop() isNew!: boolean
  private iniciado = 'Iniciado'
  private materialStore = materialStore();
  private sancionStore = sancionStore();
  private salidaStore = salidaStore();
  private materialService = MaterialService.getInstance();
  private salidaService = SalidaService.getInstance();
  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  //search = null;
  validBuscar = false;
  valid = false;
  esEdiatr= false;
  selected_funcionario = null;
  txtBuscar = '';
  cantidad= 1;
  descripcion= '';
  unidad= '';
  partida= '';
  precio_unitario_material= 0.0;
  cantidad_entregada= 1;
  precio_unitario= 1;
  isEdit = false;
  txtNroTramite = '';
  isLoading = false;
  swEditar = true;
  txtSearch = "";
  txtFuncionario = "";
  valesalida = {
    id: '',
    codigo: this.nuevoCodigoVale,
    fecha: DateTime.now().toFormat('yyyy-MM-dd'),
    item: '',
    nombre_completo: '',
    area_trabajo: '',
    tipo: 'Compra de Materiales',
    adquirido: false,
    destino: '',
    especificacion_tecnica: '',
    funcionario_id: ''
  };
  //clientes = [];
  materiales = [];
  funcionarios_all = [];

  public funcionario= {
    item: '',
    ci: '',
    nombre_completo: '',
    oficina: '',
    centro_costocompleto: ''
  };

  cliente_seleccionado = null;
  private cuenta = null;

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };

  mounted(){
    this.getNuevoCodigoVale();
    this.salidaStore.newValeSalida = [];
  }

  get valeSalidaMaterial(): any[] {
    return this.salidaStore.valeSalidaMaterial;
  }

  get nuevoValeSalida(): any[] {
    return this.salidaStore.newValeSalida;
  }

  getFuncionarios(value:string){
    this.loading
    this.salidaService.getFuncionarios(value)
  }

  get funcionarios(): any {
    return this.salidaStore.funcionarios;
  }

  seleccionFuncionario(){
    if(this.selected_funcionario !== null){
      this.valesalida.codigo = this.nuevoCodigoVale;
      this.valesalida.item = this.selected_funcionario.item;
      this.valesalida.nombre_completo = this.selected_funcionario.nombre_completo;
      this.valesalida.area_trabajo = this.selected_funcionario.area_trabajo;
      this.valesalida.funcionario_id = this.selected_funcionario.id;
      this.valesalida.area_trabajo = this.selected_funcionario.oficina;
      this.funcionario= {
        item: this.selected_funcionario.item,
        ci: this.selected_funcionario.ci,
        nombre_completo: this.selected_funcionario.nombre_completo,
        oficina: this.selected_funcionario.oficina,
        centro_costocompleto: this.selected_funcionario.centro_costocompleto
      }
    }else
      this.limpiar()

  }

  limpiar() {
    this.funcionario = {
      item: '',
      ci: '',
      nombre_completo: ''
    }
  }


  get loading(): boolean {
    return this.materialStore.loading;
  }


  get nuevoCodigoVale(): string {
    return this.salidaStore.nuevoCodigoCompraMateriales;
  }

  getNuevoCodigoVale(){
    this.salidaService.getNuevoCodigoCompra()
  }

  getMateriales(value:string) {
    this.loading;
    this.materialService.getMateriales(value);
  }

  @Watch('txtFuncionario')
  searchFuncionario(value: string) {
    if(value != null && value.length > 1){
      this.$nextTick().then( () => {
        this.getFuncionarios(value);
      })

      this.funcionarios_all = this.salidaStore.funcionarios;

    }
  }

  @Watch('txtSearch')
  search(value: string) {
    if (value != null && value.length > 2) {
      this.$nextTick().then(() => {
        this.getMateriales(value);
      })
    }
  }
  guardar(){
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Guardar el Vale de Salida del Funcionario: <br>
                    ${this.funcionario.nombre_completo}`
    ).then(res => {
      if (res.isConfirmed) {
        if (this.nuevoValeSalida.length !== 0) {
          const data = {
            valeSalidaId: this.nuevoValeSalida.id, valeSalida: this.valesalida
          }
          this.salidaService.updateValeSalida(data);
        } else {
          const data = {valeSalida: this.valesalida, codigo: this.nuevoCodigoVale}
          this.salidaService.saveCompraMateriales(data);
        }

        this.$emit('listar')
      }
    })
  }

  addMaterialValeSalida(codigo: string, valor: number) {
    if (this.cantidad > 0 && this.cantidad_entregada > 0 && this.precio_unitario > 0 && (this.cantidad >= this.cantidad_entregada)) {
      const data = {
        codigo: codigo,
        cantidad: this.cantidad,
        cantidad_entregada: this.cantidad_entregada,
        precio_unitario: valor,
        ingreso: this.nuevoValeSalida.codigo,
        ingreso_id: this.nuevoValeSalida.id
      }
      this.salidaService.addMaterialCompraMateriales(data);
      this.cantidad = 0.1;
      this.cantidad_entregada = 0.1;
      this.precio_unitario = 1;
      this.materialStore.materiales = [];
    } else {
      Alert.error('La cantidad debe ser mayor a 0, la cantidad debe ser mayor o igual a la cantidad entregada')
      return false
    }
  }

  addMaterialManual() {
    if (this.cantidad > 0 && this.cantidad_entregada > 0 && this.precio_unitario > 0 && (this.cantidad >= this.cantidad_entregada)) {
      const data = {
        cantidad: this.cantidad,
        descripcion: this.descripcion,
        unidad: this.unidad,
        precio_unitario_material: this.precio_unitario_material,
        partida: this.partida,
        ingreso: this.nuevoValeSalida.codigo,
        ingreso_id: this.nuevoValeSalida.id
      }
      this.salidaService.addMaterialManual(data);
      this.cantidad = 1;
      this.cantidad_entregada = 1;
      this.precio_unitario = 1;
      this.materialStore.materiales = [];
    } else {
      Alert.error('La cantidad debe ser mayor a 0, la cantidad debe ser mayor o igual a la cantidad entregada')
      return false
    }
  }
  deleteMaterial(id:number){
    const data = {
      id: id,
      valeSalida: this.nuevoValeSalida.codigo
    }
    this.salidaService.deleteMaterialValeSalida(data);
  }

  deleteMaterialesValeSalida(){
    const data = {
      valeSalida: this.nuevoValeSalida.codigo
    }
    this.salidaService.deleteMaterialesValeSalida(data);
  }


  imprimir(id:number){
    if (id === undefined){
      Alert.error('Primero guarde el vale de Salida')
      return false
    }
      this.salidaService.imprimirCompraMateriales(id);

  }

}
